/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Roles_DescriptionInputs */

const en_admin_roles_description = /** @type {(inputs: Admin_Roles_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage system roles and permissions`)
};

const zh_admin_roles_description = /** @type {(inputs: Admin_Roles_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理系统角色和权限`)
};

/**
* | output |
* | --- |
* | "Manage system roles and permissions" |
*
* @param {Admin_Roles_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_roles_description = /** @type {((inputs?: Admin_Roles_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_roles_description(inputs)
	return zh_admin_roles_description(inputs)
});
export { admin_roles_description as "admin.roles.description" }